module.exports = __webpack_public_path__ + "static/media/HeaderLogo_Aero.89b92b3b.svg";